import Client from "@/http/client";
import { SupportDashboardDto } from "@/http/dto/supportDashboard";

export class SupportDashboard {
  static async getDashboard(params: { periodDays: number; hotelObjectId?: string }) {
    return await Client.get<SupportDashboardDto>("/v2/supporter/dashboard", params);
  }
}
